import type { SxProps } from '@mui/material';

import { TextField } from '@theguarantors/tg-package-material-ui';

const styles: SxProps = {
  '.MuiInputLabel-root': {
    color: '#B0B0B0',
    width: '100%',
  },
  '& .MuiFilledInput-input.Mui-disabled': {
    backgroundColor: 'white',
    border: '1px solid #D1D1D1',
    color: '#B0B0B0',
    borderRadius: '4px',
  },
};

export type LeaseTextReadOnlyInputProps = {
  title: string;
  value: string;
  label: string;
  name: string;
};

export const LeaseTextReadOnlyInput = ({
  title,
  value,
  label,
  name,
}: LeaseTextReadOnlyInputProps) => {
  return (
    <TextField
      disabled
      required
      name={name}
      label={label}
      title={title}
      sx={{
        '& .MuiInputBase-root': {
          width: '100%',
        },
        width: '100%',
        ...styles,
      }}
      value={value}
    />
  );
};
